import React, { useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import Logo from '../../img/fpg_logo.png'; // Make sure this path is right!

// --- STYLES ---
const styles = {
  navBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '80px',
    backgroundColor: '#ffffff', // CHANGED: White Background
    borderBottom: '1px solid #eaeaea', // Subtle light grey border
    padding: '0 40px',
    color: '#333', // CHANGED: Dark Text
    position: 'relative',
    zIndex: 1000,
    boxShadow: '0 2px 10px rgba(0,0,0,0.05)', // Soft shadow for depth
  },
  navGroup: {
    display: 'flex',
    gap: '30px', // Space between buttons
    alignItems: 'center',
  },
  linkText: {
    textDecoration: 'none',
    color: '#333', 
    fontSize: '16px', // Slightly smaller for a cleaner look
    fontWeight: '600', 
    transition: 'color 0.2s',
    textTransform: 'uppercase', // Adds a bit of "Studio" polish
    letterSpacing: '1px',
  },
  activeLink: {
    color: '#b026ff', // Keep the Purple Accent!
    fontWeight: 'bold',
  },
  // Dropdown Styles
  dropdownContainer: {
    position: 'relative',
    cursor: 'pointer',
  },
  dropdownMenu: {
    position: 'absolute',
    top: '100%', // Right below the text
    left: '-10px',
    backgroundColor: '#252525', // Slightly lighter than bg
    minWidth: '160px',
    boxShadow: '0px 8px 16px rgba(0,0,0,0.5)',
    borderRadius: '4px',
    padding: '10px 0',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #333',
    backgroundColor: '#ffffff',
  },
  dropdownItem: {
    padding: '10px 20px',
    textDecoration: 'none',
    color: '#f0f0f0',
    display: 'block',
    fontSize: '16px',
    color: '#333',
  }
};

export default function PageHeader() {
  const location = useLocation(); // Get current URL path
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  // Helper to check active state
  const isActive = (path) => location.pathname === path;

  return (
    <div style={styles.navBar}>
      {/* LOGO AREA */}
      <Link to="/home">
        <img src={Logo} style={{ height: '50px', width: 'auto' }} alt="Foreplay Games" />
      </Link>

      {/* NAVIGATION AREA */}
      <div style={styles.navGroup}>
        
        {/* HOME LINK */}
        <Link 
          to="/home" 
          style={{ 
            ...styles.linkText, 
            ...(isActive('/home') ? styles.activeLink : {}) 
          }}
        >
          Home
        </Link>

        {/* GAMES DROPDOWN */}
        <div 
          style={styles.dropdownContainer}
          onMouseEnter={() => setDropdownOpen(true)}
          onMouseLeave={() => setDropdownOpen(false)}
        >
          <span style={{ 
            ...styles.linkText, 
            ...(location.pathname.includes('/games') ? styles.activeLink : {}) 
          }}>
            Games ▾
          </span>

          {isDropdownOpen && (
            <div style={styles.dropdownMenu}>
              <Link 
                to="/games/3xr" 
                style={styles.dropdownItem}
                className="dropdown-hover" // You can add CSS hover effects in App.css for this
              >
                3XRay
              </Link>
              <Link to="/games/lonelyhands" style={styles.dropdownItem} className="dropdown-hover">
                LonelyHands
              </Link>
              {/* Add Forest Folly later */}
            </div>
          )}
        </div>

        {/* NEW: DEVLOG */}
        <Link 
          to="/devlog" 
          style={{ ...styles.linkText, ...(isActive('/devlog') ? styles.activeLink : {}) }}
        >
          Devlog
        </Link>

        <Link 
          to="/jobs" 
          style={{ ...styles.linkText, ...(isActive('/jobs') ? styles.activeLink : {}) }}
        >
          Jobs
        </Link>

        {/* NEW: FAQ */}
        <Link 
          to="/faq" 
          style={{ ...styles.linkText, ...(isActive('/faq') ? styles.activeLink : {}) }}
        >
          FAQ
        </Link>

        <Link 
          to="/ai-policy" 
          style={{ ...styles.linkText, ...(isActive('/ai-policy') ? styles.activeLink : {}) }}
        >
          AI Policy
        </Link>

      </div>
    </div>
  );
}